import * as actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  user: {},
  userFullName: '',
  userRole: '',
  userObj: {},
  users: [],
  advisor: {},
  permission: {},
  careerGoal: '',
  userPreferences: {},
  zendeskWidgetId: '',
  zendeskWidgetToken: '',
  zendeskWidgetTheme: '',
  tempUser: false,
  currentPage: '',
  forceResetTourElements: false
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/app/user/vuex/index.js